import { FilterItem, FilterType } from '@warema/shared/shop/shared/filters/models';
import { Musters } from './Musters';

export const filters: Array<FilterItem> = [
    {
        id: '01',
        name: 'SHOP.FILTER_PRODUCT_FAMILY_TERREA_AWNINGS',
        iconPath: 'shared-assets/icons/shop/terrea_markise.svg',
        cssBackground: '',
        selected: false,
        filterType: FilterType.productFamilies,
        analyticsValue: 'Terrea Markisen',
    },
    {
        id: '02',
        name: 'SHOP.FILTER_PRODUCT_FAMILY_CLIMARA_AWNINGS',
        iconPath: 'shared-assets/icons/shop/climara_markisen.svg',
        cssBackground: '',
        selected: false,
        filterType: FilterType.productFamilies,
        analyticsValue: 'Climara Markisen',
    },
    {
        id: '04',
        name: 'SHOP.FILTER_PRODUCT_FAMILY_PEREA_AWNINGS',
        iconPath: 'shared-assets/icons/shop/perea_markise.svg',
        cssBackground: '',
        selected: false,
        filterType: FilterType.productFamilies,
        analyticsValue: 'Perea Markisen',
    },
    {
        id: '041-042',
        name: 'SHOP.FILTER_PRODUCT_FAMILY_PEREA_AWNINGS_WATERPROOF',
        iconPath: 'shared-assets/icons/shop/perea_markise_wetterfest.svg',
        cssBackground: '',
        selected: false,
        filterType: FilterType.productFamilies,
        analyticsValue: 'Perea Markisen wetterfest',
    },
    {
        id: '03',
        name: 'SHOP.FILTER_PRODUCT_FAMILY_WINDOW_AWNINGS',
        iconPath: 'shared-assets/icons/shop/fenster_markisen.svg',
        cssBackground: '',
        selected: false,
        filterType: FilterType.productFamilies,
        analyticsValue: 'Fenster-Markisen',
    },
    {
        id: '09',
        name: 'SHOP.FILTER_PRODUCT_FAMILY_SONEA_AWNINGS',
        iconPath: 'shared-assets/icons/shop/sonea_sonnensegel.svg',
        cssBackground: '',
        selected: false,
        filterType: FilterType.productFamilies,
        analyticsValue: 'Sonea Sonnensegel',
    },
    // enable for future (doesnt exist now)
    // {
    //     id: '07',
    //     name: 'SHOP.FILTER_PRODUCT_FAMILY_LOUVRE_ROOF',
    //     iconPath: 'assets/images/icons/shop/icon_lamellendach.svg',
    //     cssBackground: '',
    //     selected: false,
    //     filterType: FilterType.productFamilies,
    // },
    {
        id: '01',
        name: 'SHOP.FILTER_WHITE',
        cssBackground: 'white',
        iconPath: '',
        selected: false,
        filterType: FilterType.colors,
        analyticsValue: 'Weiß',
    },
    {
        id: '04',
        name: 'SHOP.FILTER_METALLIC',
        cssBackground: 'linear-gradient(to left, #8b8d8e, #eee, #aeafb0)',
        iconPath: '',
        selected: false,
        filterType: FilterType.colors,
        analyticsValue: 'Metallic',
    },
    {
        id: '02',
        name: 'SHOP.FILTER_GREY',
        cssBackground: '#a5a5a5',
        iconPath: '',
        selected: false,
        filterType: FilterType.colors,
        analyticsValue: 'Grau',
    },
    {
        id: '03',
        name: 'SHOP.FILTER_BLACK',
        cssBackground: '#000',
        iconPath: '',
        selected: false,
        filterType: FilterType.colors,
        analyticsValue: 'Schwarz',
    },
    {
        id: '11',
        name: 'SHOP.FILTER_BLUE',
        cssBackground: '#3489cb',
        iconPath: '',
        selected: false,
        filterType: FilterType.colors,
        analyticsValue: 'Blau',
    },
    {
        id: '10',
        name: 'SHOP.FILTER_GREEN',
        cssBackground: '#06944e',
        iconPath: '',
        selected: false,
        filterType: FilterType.colors,
        analyticsValue: 'Grün',
    },
    {
        id: '08',
        name: 'SHOP.FILTER_YELLOW',
        cssBackground: '#f6c845',
        iconPath: '',
        selected: false,
        filterType: FilterType.colors,
        analyticsValue: 'Gelb',
    },
    {
        id: '09',
        name: 'SHOP.FILTER_ORANGE',
        cssBackground: '#f98f25',
        iconPath: '',
        selected: false,
        filterType: FilterType.colors,
        analyticsValue: 'Orange',
    },
    {
        id: '05',
        name: 'SHOP.FILTER_RED',
        cssBackground: '#d4001a',
        iconPath: '',
        selected: false,
        filterType: FilterType.colors,
        analyticsValue: 'Rot',
    },
    {
        id: '06',
        name: 'SHOP.FILTER_ROSE',
        cssBackground: '#f5a3f5',
        iconPath: '',
        selected: false,
        filterType: FilterType.colors,
        analyticsValue: 'Rosa',
    },
    {
        id: '07',
        name: 'SHOP.FILTER_VIOLET',
        cssBackground: '#7c3ba8',
        iconPath: '',
        selected: false,
        filterType: FilterType.colors,
        analyticsValue: 'Violett',
    },
    {
        id: '13',
        name: 'SHOP.FILTER_BROWN',
        cssBackground: '#884228',
        iconPath: '',
        selected: false,
        filterType: FilterType.colors,
        analyticsValue: 'Braun',
    },
    {
        id: '12',
        name: 'SHOP.FILTER_BEIGE',
        cssBackground: '#fcf0da',
        iconPath: '',
        selected: false,
        filterType: FilterType.colors,
        analyticsValue: 'Beige',
    },
    // {
    //     id: '14',
    //     name: 'SHOP.FILTER_COLOURFUL',
    //     cssBackground:
    //         'linear-gradient(to right, #f22bbc, #ae36e3 13%, #4a45cf 27%, #30e8e8 41%, #2fe228 59%, #faf103 72%, #ff9d00 87%, #e62525)',
    //     iconPath: '',
    //     selected: false,
    //     filterType: FilterType.colors,
    // },
    {
        id: Musters.USEbizUnicolour,
        name: 'SHOP.FILTER_MUSTER_PLAIN',
        iconPath: '',
        cssBackground: '',
        selected: false,
        filterType: FilterType.muster,
        analyticsValue: 'Einfarbig',
    },
    {
        id: Musters.USEbizStripes,
        name: 'SHOP.FILTER_MUSTER_STRIP',
        iconPath: '',
        cssBackground: '',
        selected: false,
        filterType: FilterType.muster,
        analyticsValue: 'Streifen',
    },
];
